module.exports = __webpack_public_path__ + "static/media/Dashboard_info.fc8268fb.png";